module.exports = __webpack_public_path__ + "static/media/folder_active.b98dd671.svg";